// extracted by mini-css-extract-plugin
module.exports = {"container":"Faq_container__KBEw9","faqList":"Faq_faqList__E4gK0","enquiryFormLink":"Faq_enquiryFormLink__uA4aY"};